export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@\[-`{-~]).{6,64}$/;

export const validText = (text, minLength) => {
    if (
        !text ||
        (typeof text === "string" && text.trim() === "") ||
        text.length < minLength
    ) {
        return false;
    }
    return true;
};

export const validEmail = (email) => {
    if (!email) {
        return false;
    }
    return PASSWORD_REGEX.test(email);
};
export const validateSelect = (value) => {
    return value !== null;


}

export const validator = (context, validations = []) => {
    let valid = 0;
    const errors = [];
    validations.forEach((validation) => {
        const value = context[validation.field];
        switch (validation.type) {
            case "email":
                if (!validEmail(value)) {
                    valid--;
                    errors.push({field: validation.field, error: validation.error});
                }
                break;
            case "select":
                if (validateSelect(value)) {
                    valid--;
                    errors.push({field: validation.field, error: validation.error});
                }
                break;
            default:
                if (!validText(value, validation.minLength)) {
                    valid--;
                    errors.push({field: validation.field, error: validation.error});
                }
        }
    });
    return {result: valid === 0, errors};
};
